import { AttioValuationFilter } from 'dashboard409a/common/constants/analyst-dashboard';
import { useCalendarState } from 'dashboard409a/hooks/useCalendarState';
import { useValuationsWithBulkData } from 'dashboard409a/hooks/useValuationsWithBulkData';
import { SimplifiedAttioValuation } from 'dashboard409a/services/attio.types';
import ValuationsCalendar from './ValuationsCalendar';
import { CALENDAR_VIEWS, VALUATIONS_CALENDAR_DATE_KEY, VALUATIONS_CALENDAR_VIEW_KEY } from '../../common/constants/calendar';
import CalendarToolbar from '../ModelsCalendar/components/CalendarToolbar';
import CalendarWithToolbarLayout from '../ModelsCalendar/components/CalendarWithToolbarLayout';

interface ValuationsCalendarWithToolbarProps {
  filters: AttioValuationFilter;
  onSelectEvent?: (valuation: SimplifiedAttioValuation) => void;
}

const ValuationsCalendarWithToolbar = ({ filters, onSelectEvent }: ValuationsCalendarWithToolbarProps) => {
  const { rows: valuations, isLoading } = useValuationsWithBulkData({ filters });
  const { calendarDate, setCalendarDate, calendarView, handleCalendarNavigate, handleCalendarViewChange } =
    useCalendarState({ dateStorageKey: VALUATIONS_CALENDAR_DATE_KEY, viewStorageKey: VALUATIONS_CALENDAR_VIEW_KEY });

  return (
    <CalendarWithToolbarLayout
      toolbar={(
        <CalendarToolbar
          date={calendarDate}
          view={calendarView}
          onNavigate={handleCalendarNavigate}
          onViewChange={handleCalendarViewChange}
          onDateSelect={setCalendarDate}
          views={[...CALENDAR_VIEWS]}
        />
      )}
    >
      <ValuationsCalendar
        valuations={valuations}
        isLoading={isLoading}
        onSelectEvent={onSelectEvent}
        hideToolbar
        controlledDate={calendarDate}
        controlledView={calendarView}
        onDateChange={setCalendarDate}
        onViewChange={handleCalendarViewChange}
      />
    </CalendarWithToolbarLayout>
  );
};

export default ValuationsCalendarWithToolbar;
